import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  to?: string;
}

export default function EmptyState({
  icon = "ri-inbox-archive-line",
  title,
  description,
  actionLabel,
  onAction,
  to,
}: EmptyStateProps) {
  return (
    <div className="w-full flex flex-col items-center justify-center py-16 md:py-24 px-4 text-center">
      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className={`${icon} text-3xl`}></i>
      </span>
      <h3 className="mt-5 font-heading text-lg md:text-xl font-bold text-foreground-900">{title}</h3>
      <p className="mt-2 text-sm text-foreground-600 max-w-md leading-7">{description}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-refresh-line"></i>
          {actionLabel}
        </button>
      )}
      {actionLabel && !onAction && to && (
        <Link
          to={to}
          className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          {actionLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}